<template>
  <span class="diff-value-compare">
    <template v-if="resolvedMode === 'create'">
      <code class="ant-tag-green">
        <SearchHighlightText :text="displayNew" :keyword="keyword" />
      </code>
    </template>
    <template v-else-if="resolvedMode === 'delete'">
      <code class="ant-tag-red">
        <SearchHighlightText :text="displayOld" :keyword="keyword" />
      </code>
    </template>
    <template v-else>
      <code class="ant-tag-red">
        <SearchHighlightText :text="displayOld" :keyword="keyword" />
      </code>
      <span class="diff-value-compare__arrow">=></span>
      <code class="ant-tag-green">
        <SearchHighlightText :text="displayNew" :keyword="keyword" />
      </code>
    </template>
  </span>
</template>

<script>
import { computed } from 'vue'
import SearchHighlightText from './SearchHighlightText.vue'

export const formatValue = (v) => {
  if (v === undefined || v === null) return ''
  if (typeof v === 'object') {
    try {
      return JSON.stringify(v)
    } catch (e) {
      return String(v)
    }
  }
  return String(v)
}

export default {
  name: 'DiffValueCompare',
  components: { SearchHighlightText },
  props: {
    oldValue: { default: undefined },
    newValue: { default: undefined },
    /** create | delete | update；未傳則依 oldValue／newValue 是否為 undefined 推斷 */
    mode: { type: String, default: '' },
    keyword: { type: String, default: '' },
  },
  setup(props) {
    const resolvedMode = computed(() => {
      if (props.mode) return props.mode
      if (props.oldValue === undefined && props.newValue !== undefined) return 'create'
      if (props.newValue === undefined && props.oldValue !== undefined) return 'delete'
      return 'update'
    })

    const displayOld = computed(() => formatValue(props.oldValue))
    const displayNew = computed(() => formatValue(props.newValue))

    return {
      resolvedMode,
      displayOld,
      displayNew,
    }
  },
}
</script>

<style>
.diff-value-compare {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: flex-start;
  min-width: 0;
  max-width: 100%;
  vertical-align: middle;
}

.diff-value-compare__arrow {
  flex-shrink: 0;
  margin: 0 4px;
  color: rgba(0, 0, 0, 0.45);
}

.diff-value-compare code.ant-tag-red,
.diff-value-compare code.ant-tag-green {
  min-height: 20px;
  min-width: 8px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
